<template>
  <BaseText
    inline
    :href="demoWebsiteUrl"
    v-test="'website-service-demo-button'"
  >
    {{ $t('website_service.banner.secondary_action') }}
  </BaseText>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useLocalizationStore } from '@/stores/localization';

const { language } = storeToRefs(useLocalizationStore());

const demoWebsiteUrl = computed(() => {
  const supportedLanguages = ['en', 'de', 'nl'];
  const lang = supportedLanguages.includes(language.value)
    ? language.value
    : 'en';
  return `https://${lang}.chez-sally.com`;
});
</script>
